// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.real-id-order-widget {
  font-size: 13px;
  line-height: 1.5;
  color: #1d2327;
}

.real-id-order-widget--loading {
  color: #646970;
  padding: 8px 0;
}

.real-id-order-widget__header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.real-id-order-widget__applicant {
  font-weight: 600;
}

.real-id-order-widget__status {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.6;
  white-space: nowrap;
}

.real-id-order-widget__status--success {
  background: #d7f5dd;
  color: #14622b;
}

.real-id-order-widget__status--critical {
  background: #fcdede;
  color: #8a1c1c;
}

.real-id-order-widget__status--warning {
  background: #fcf2d3;
  color: #8a6116;
}

.real-id-order-widget__status--info {
  background: #e2e8f5;
  color: #2c3a59;
}

.real-id-order-widget__fields {
  margin: 0 0 14px;
}

.real-id-order-widget__field {
  margin: 0 0 6px;
}

.real-id-order-widget__field dt {
  font-weight: 600;
  color: #646970;
  margin: 0;
}

.real-id-order-widget__field dd {
  margin: 0;
}

.real-id-order-widget__photos {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 14px;
  max-width: 360px;
}

.real-id-order-widget__photo {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
}

.real-id-order-widget__photo-label {
  font-size: 11px;
  font-weight: 600;
  color: #646970;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.real-id-order-widget__photo-controls {
  display: flex;
  gap: 4px;
  margin-bottom: 4px;
}

.real-id-order-widget__rotate-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  padding: 0;
  border: 1px solid #c3c4c7;
  border-radius: 50%;
  background: #fff;
  color: #50575e;
  cursor: pointer;
  box-sizing: border-box;
}

.real-id-order-widget__rotate-btn:hover {
  background: #f0f0f1;
}

.real-id-order-widget__photo-frame {
  position: relative;
  display: block;
  padding: 0;
  width: 100%;
  border: 1px solid #dcdcde;
  border-radius: 4px;
  background: #fff;
  cursor: zoom-in;
  overflow: hidden;
}

.real-id-order-widget__photo-frame:hover {
  background: #f6f7f7;
}

.real-id-order-widget__photo-img {
  display: block;
  width: 100%;
  max-height: 320px;
  height: auto;
  -o-object-fit: contain;
     object-fit: contain;
  margin: 0 auto;
}

.real-id-order-widget__carousel-controls {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 8px;
}

.real-id-order-widget__carousel-indicator {
  font-size: 11px;
  font-weight: 600;
  color: #646970;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.real-id-order-widget__bbox {
  position: absolute;
  display: block;
  z-index: 2;
  border: 2px solid #2271b1;
  box-sizing: border-box;
  pointer-events: none;
}

.real-id-order-widget__bbox--id {
  border-color: #2271b1;
}

.real-id-order-widget__bbox--match {
  border-color: #14622b;
}

.real-id-order-widget__bbox--mismatch {
  border-color: #8a1c1c;
  background: conic-gradient(
      rgb(236 89 136 / 16%) 25%,
      rgb(214 31 31 / 10%) 0 50%,
      rgb(204 42 42 / 30%) 0 75%,
      rgb(245 57 57 / 20%) 0
    )
    0 0 / 10px 10px;
}

.real-id-order-widget__mismatch-badge {
  position: absolute;
  right: 6px;
  top: 6px;
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 3px 6px;
  background: #fff;
  color: #1d2327;
  border-radius: 3px;
  font-size: 10px;
  font-weight: 600;
  z-index: 3;
}

.real-id-order-widget__mismatch-badge svg {
  width: 12px;
  height: 12px;
  color: #dba617;
}

.real-id-order-widget__sandbox-banner {
  position: relative;
  z-index: 4;
  padding: 4px 8px;
  background: #d63638;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.real-id-order-widget__lightbox {
  position: fixed;
  inset: 0;
  z-index: 100100;
  background: rgba(15, 23, 42, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
  box-sizing: border-box;
}

.real-id-order-widget__lightbox-close {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.92);
  color: #1d2327;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.real-id-order-widget__lightbox-controls {
  position: absolute;
  top: 16px;
  left: 16px;
  display: flex;
  gap: 6px;
}

.real-id-order-widget__lightbox-controls .real-id-order-widget__rotate-btn {
  width: 36px;
  height: 36px;
  background: rgba(255, 255, 255, 0.92);
  border-color: transparent;
}

.real-id-order-widget__lightbox-frame {
  position: relative;
  max-width: min(90vw, 1200px);
  max-height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.real-id-order-widget__lightbox-img {
  display: block;
  max-width: 100%;
  max-height: 90vh;
  width: auto;
  height: auto;
  -o-object-fit: contain;
     object-fit: contain;
  background: #fff;
}

.real-id-order-widget__liability-dialog-backdrop {
  position: fixed;
  inset: 0;
  z-index: 100100;
  background: rgba(15, 23, 42, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  box-sizing: border-box;
}

.real-id-order-widget__liability-dialog {
  width: 100%;
  max-width: 460px;
  background: #fff;
  border-radius: 4px;
  padding: 20px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);
}

.real-id-order-widget__liability-dialog h3 {
  margin: 0 0 12px;
  font-size: 16px;
  font-weight: 600;
  color: #1d2327;
}

.real-id-order-widget__liability-dialog p {
  margin: 0 0 12px;
  font-size: 13px;
  line-height: 1.5;
  color: #1d2327;
}

.real-id-order-widget__liability-dialog label {
  display: flex;
  gap: 8px;
  align-items: flex-start;
  margin: 12px 0;
  font-size: 13px;
}

.real-id-order-widget__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 6px;
}

.real-id-order-widget__confirm {
  border: 1px solid #dcdcde;
  border-radius: 4px;
  padding: 12px;
  margin-bottom: 12px;
  background: #f6f7f7;
}

.real-id-order-widget__confirm p {
  margin: 0 0 8px;
}

.real-id-order-widget__confirm label {
  display: block;
  margin-bottom: 6px;
}

.real-id-order-widget__notice {
  padding: 8px 12px;
  border-radius: 4px;
  margin-bottom: 12px;
  border-left: 4px solid transparent;
}

.real-id-order-widget__notice--success {
  background: #edfaef;
  border-left-color: #14622b;
}

.real-id-order-widget__notice--error {
  background: #fcf0f1;
  border-left-color: #8a1c1c;
}

.real-id-order-widget__notice--info {
  background: #eef1f7;
  border-left-color: #2c3a59;
  color: #2c3a59;
}

.real-id-order-widget__footer {
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px solid #f0f0f1;
}

.real-id-order-widget__details-link {
  font-weight: 600;
}

.real-id-order-widget__main {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 14px;
}

.real-id-order-widget__main-col {
  flex: 1 1 240px;
  min-width: 240px;
  margin: 0;
}

.real-id-order-widget__check-link {
  margin-bottom: 14px;
  max-width: 360px;
}

.real-id-order-widget__check-link-label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  color: #646970;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  margin-bottom: 4px;
}

.real-id-order-widget__check-link-row {
  display: flex;
  gap: 6px;
}

.real-id-order-widget__check-link-input {
  flex: 1;
  min-width: 0;
  padding: 4px 8px;
  border: 1px solid #dcdcde;
  border-radius: 4px;
  background: #f6f7f7;
  color: #1d2327;
  font-size: 12px;
  font-family: inherit;
}

`, "",{"version":3,"sources":["webpack://./src/components/order/orderWidget.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,sBAAmB;KAAnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB;;;;;;mBAMiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,eAAe;EACf,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,sBAAmB;KAAnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,eAAe;EACf,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB","sourcesContent":[".real-id-order-widget {\n  font-size: 13px;\n  line-height: 1.5;\n  color: #1d2327;\n}\n\n.real-id-order-widget--loading {\n  color: #646970;\n  padding: 8px 0;\n}\n\n.real-id-order-widget__header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.real-id-order-widget__applicant {\n  font-weight: 600;\n}\n\n.real-id-order-widget__status {\n  display: inline-block;\n  padding: 2px 10px;\n  border-radius: 10px;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.6;\n  white-space: nowrap;\n}\n\n.real-id-order-widget__status--success {\n  background: #d7f5dd;\n  color: #14622b;\n}\n\n.real-id-order-widget__status--critical {\n  background: #fcdede;\n  color: #8a1c1c;\n}\n\n.real-id-order-widget__status--warning {\n  background: #fcf2d3;\n  color: #8a6116;\n}\n\n.real-id-order-widget__status--info {\n  background: #e2e8f5;\n  color: #2c3a59;\n}\n\n.real-id-order-widget__fields {\n  margin: 0 0 14px;\n}\n\n.real-id-order-widget__field {\n  margin: 0 0 6px;\n}\n\n.real-id-order-widget__field dt {\n  font-weight: 600;\n  color: #646970;\n  margin: 0;\n}\n\n.real-id-order-widget__field dd {\n  margin: 0;\n}\n\n.real-id-order-widget__photos {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 14px;\n  max-width: 360px;\n}\n\n.real-id-order-widget__photo {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  width: 100%;\n}\n\n.real-id-order-widget__photo-label {\n  font-size: 11px;\n  font-weight: 600;\n  color: #646970;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.real-id-order-widget__photo-controls {\n  display: flex;\n  gap: 4px;\n  margin-bottom: 4px;\n}\n\n.real-id-order-widget__rotate-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  padding: 0;\n  border: 1px solid #c3c4c7;\n  border-radius: 50%;\n  background: #fff;\n  color: #50575e;\n  cursor: pointer;\n  box-sizing: border-box;\n}\n\n.real-id-order-widget__rotate-btn:hover {\n  background: #f0f0f1;\n}\n\n.real-id-order-widget__photo-frame {\n  position: relative;\n  display: block;\n  padding: 0;\n  width: 100%;\n  border: 1px solid #dcdcde;\n  border-radius: 4px;\n  background: #fff;\n  cursor: zoom-in;\n  overflow: hidden;\n}\n\n.real-id-order-widget__photo-frame:hover {\n  background: #f6f7f7;\n}\n\n.real-id-order-widget__photo-img {\n  display: block;\n  width: 100%;\n  max-height: 320px;\n  height: auto;\n  object-fit: contain;\n  margin: 0 auto;\n}\n\n.real-id-order-widget__carousel-controls {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.real-id-order-widget__carousel-indicator {\n  font-size: 11px;\n  font-weight: 600;\n  color: #646970;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.real-id-order-widget__bbox {\n  position: absolute;\n  display: block;\n  z-index: 2;\n  border: 2px solid #2271b1;\n  box-sizing: border-box;\n  pointer-events: none;\n}\n\n.real-id-order-widget__bbox--id {\n  border-color: #2271b1;\n}\n\n.real-id-order-widget__bbox--match {\n  border-color: #14622b;\n}\n\n.real-id-order-widget__bbox--mismatch {\n  border-color: #8a1c1c;\n  background: conic-gradient(\n      rgb(236 89 136 / 16%) 25%,\n      rgb(214 31 31 / 10%) 0 50%,\n      rgb(204 42 42 / 30%) 0 75%,\n      rgb(245 57 57 / 20%) 0\n    )\n    0 0 / 10px 10px;\n}\n\n.real-id-order-widget__mismatch-badge {\n  position: absolute;\n  right: 6px;\n  top: 6px;\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  padding: 3px 6px;\n  background: #fff;\n  color: #1d2327;\n  border-radius: 3px;\n  font-size: 10px;\n  font-weight: 600;\n  z-index: 3;\n}\n\n.real-id-order-widget__mismatch-badge svg {\n  width: 12px;\n  height: 12px;\n  color: #dba617;\n}\n\n.real-id-order-widget__sandbox-banner {\n  position: relative;\n  z-index: 4;\n  padding: 4px 8px;\n  background: #d63638;\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n  text-align: center;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.real-id-order-widget__lightbox {\n  position: fixed;\n  inset: 0;\n  z-index: 100100;\n  background: rgba(15, 23, 42, 0.85);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 32px;\n  box-sizing: border-box;\n}\n\n.real-id-order-widget__lightbox-close {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  width: 36px;\n  height: 36px;\n  border: none;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.92);\n  color: #1d2327;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.real-id-order-widget__lightbox-controls {\n  position: absolute;\n  top: 16px;\n  left: 16px;\n  display: flex;\n  gap: 6px;\n}\n\n.real-id-order-widget__lightbox-controls .real-id-order-widget__rotate-btn {\n  width: 36px;\n  height: 36px;\n  background: rgba(255, 255, 255, 0.92);\n  border-color: transparent;\n}\n\n.real-id-order-widget__lightbox-frame {\n  position: relative;\n  max-width: min(90vw, 1200px);\n  max-height: 90vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.real-id-order-widget__lightbox-img {\n  display: block;\n  max-width: 100%;\n  max-height: 90vh;\n  width: auto;\n  height: auto;\n  object-fit: contain;\n  background: #fff;\n}\n\n.real-id-order-widget__liability-dialog-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 100100;\n  background: rgba(15, 23, 42, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  box-sizing: border-box;\n}\n\n.real-id-order-widget__liability-dialog {\n  width: 100%;\n  max-width: 460px;\n  background: #fff;\n  border-radius: 4px;\n  padding: 20px;\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);\n}\n\n.real-id-order-widget__liability-dialog h3 {\n  margin: 0 0 12px;\n  font-size: 16px;\n  font-weight: 600;\n  color: #1d2327;\n}\n\n.real-id-order-widget__liability-dialog p {\n  margin: 0 0 12px;\n  font-size: 13px;\n  line-height: 1.5;\n  color: #1d2327;\n}\n\n.real-id-order-widget__liability-dialog label {\n  display: flex;\n  gap: 8px;\n  align-items: flex-start;\n  margin: 12px 0;\n  font-size: 13px;\n}\n\n.real-id-order-widget__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 6px;\n}\n\n.real-id-order-widget__confirm {\n  border: 1px solid #dcdcde;\n  border-radius: 4px;\n  padding: 12px;\n  margin-bottom: 12px;\n  background: #f6f7f7;\n}\n\n.real-id-order-widget__confirm p {\n  margin: 0 0 8px;\n}\n\n.real-id-order-widget__confirm label {\n  display: block;\n  margin-bottom: 6px;\n}\n\n.real-id-order-widget__notice {\n  padding: 8px 12px;\n  border-radius: 4px;\n  margin-bottom: 12px;\n  border-left: 4px solid transparent;\n}\n\n.real-id-order-widget__notice--success {\n  background: #edfaef;\n  border-left-color: #14622b;\n}\n\n.real-id-order-widget__notice--error {\n  background: #fcf0f1;\n  border-left-color: #8a1c1c;\n}\n\n.real-id-order-widget__notice--info {\n  background: #eef1f7;\n  border-left-color: #2c3a59;\n  color: #2c3a59;\n}\n\n.real-id-order-widget__footer {\n  margin-top: 12px;\n  padding-top: 10px;\n  border-top: 1px solid #f0f0f1;\n}\n\n.real-id-order-widget__details-link {\n  font-weight: 600;\n}\n\n.real-id-order-widget__main {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin-bottom: 14px;\n}\n\n.real-id-order-widget__main-col {\n  flex: 1 1 240px;\n  min-width: 240px;\n  margin: 0;\n}\n\n.real-id-order-widget__check-link {\n  margin-bottom: 14px;\n  max-width: 360px;\n}\n\n.real-id-order-widget__check-link-label {\n  display: block;\n  font-size: 11px;\n  font-weight: 600;\n  color: #646970;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n  margin-bottom: 4px;\n}\n\n.real-id-order-widget__check-link-row {\n  display: flex;\n  gap: 6px;\n}\n\n.real-id-order-widget__check-link-input {\n  flex: 1;\n  min-width: 0;\n  padding: 4px 8px;\n  border: 1px solid #dcdcde;\n  border-radius: 4px;\n  background: #f6f7f7;\n  color: #1d2327;\n  font-size: 12px;\n  font-family: inherit;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
